import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DamageReasonsDto } from './item-damage-reason.dto';


export class AllItemDamageReasonsResponse extends GlobalResponseObject{
    data?: DamageReasonsDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: DamageReasonsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

